import preset from '@/@core/preset/preset'
import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import {mdiShieldAlert} from  '@mdi/js'
import i18n from '@/lang'
import * as components from 'vuetify/lib/components'
import * as directives from 'vuetify/lib/directives'


const install = Vuetify.install
Vuetify.install = (Vue, args) => {
    install.call(Vuetify, Vue, {
        components,
        directives,
        ...args,
    })
}
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Vuetify)
}

Vue.use(Vuetify)

const opts = {
    preset,
    icons: {
        iconfont: 'mdiSvg',
        values:{
            warning: mdiShieldAlert,
        }
    },
    lang: {
        t: (key, ...params) => {
            return i18n.t(key, params)
        }
    },
    theme: {
        options: {
            customProperties: true,
            variations: false,
        },
    }
}

export default new Vuetify(opts)
